<template>
  <div>
    <div class="row form-card mx-0">
      <div class="w-100 mb-2 input-group">
        <div class="col-3 d-inline-block" style="margin-top:0.6rem">
          <label for="name">Select Client</label><br>
          <vue-typeahead-bootstrap
            id="name"
            size="lg"
            v-model="clientQuery"
            :data="clients"
            :serializer="client => client.name"
            @hit="invoice.client = $event"/>

<!--          <b-form-select v-model="invoice.client" :options="options"></b-form-select>-->
        </div>
        <div class="col-2 d-inline-block" style="margin-top:0.6rem">
          <label for="type">Payment Option</label><br>
          <b-form-select size="lg" v-model="invoice.paymentType" :options="paymentTypeOptions"></b-form-select>
        </div>
        <div class="col-1 d-inline-block" style="margin-top: 0.6rem">
          <label :class="invoice.paid ? 'text-success' : 'text-warning'" for="paid"> {{ invoice.paid ? 'PAID' : 'PENDING' }} </label><br>
          <b-form-checkbox v-model="invoice.paid" size="lg" name="check-button" class="pt-2" switch>
<!--            {{ invoice.paid ? 'PAID' : 'PENDING' }}-->
          </b-form-checkbox>
        </div>
        <div class="col-4 d-inline-block text-center align-self-center" style="margin-top: 0.6rem">
          <div class="plate">
            <!-- <label for="name">Licence Plate</label> -->
            <input v-model="reg" maxlength="7" type="text" name="number" id="plate" autocomplete="off" placeholder="Reg">
          </div>
        </div>
        <div class="col-2 d-inline-block text-center align-self-center" style="margin-top: 0.6rem">
          <div class="cash-display">
            <span>kr {{currentTotal.toLocaleString() || 0}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row form-card scan-bar mx-0 mt-3 pt-3">
      <b-col sm="5">
        <b-form-input v-if="qrInput" style="font-size: 1.3rem; color: white" class="bg-dark"
          ref="qr"
          size="lg"
          v-model="qr"
          v-on:keyup.enter="qr2articles"
          placeholder="SCAN QR CODE">
        </b-form-input>
        <b-form-input v-else-if="inputEAN && !qrInput" style="font-size: 1.3rem; color: white" class="bg-dark"
          ref="ean"
          size="lg"
          v-model="ean"
          v-on:keyup.enter="sku2article"
          placeholder="SCAN EAN CODE"></b-form-input>
        <b-form-input v-else style="font-size: 1.3rem; color: white" class="bg-dark"
          ref="ean"
          size="lg"
          v-model="sku"
          v-on:keyup.enter="sku2article"
          placeholder="ENTER SKU CODE"></b-form-input>
        <br>
      </b-col>
      <b-col sm="2">
        <b-form-select v-model="shelf"
                       :options="shelfOptions"
                       :disabled="!currentOrder.metaData || !currentOrder.packedAt"
                       size="lg"
                       class="bg-dark text-white shelf"
                       placeholder="Shelf"></b-form-select>
      </b-col>
      <b-col sm="2">
        <b-button @click="sku2article" variant="primary" size="lg" block><b-icon-plus></b-icon-plus>Add</b-button>
      </b-col>
      <b-col sm="2">
        <b-form-checkbox :disabled="qrInput" v-model="inputEAN" size="lg" name="check-button" class="text-center p-2 pos-switch" switch>
          {{ inputEAN ? 'EAN' : 'SKU' }}
        </b-form-checkbox>
      </b-col><b-col>
        <b-button @click="qrInput = !qrInput" size="lg" variant="secondary"><b-icon-upc-scan></b-icon-upc-scan></b-button>
      </b-col>
    </div>
    <div class="row mx-0" v-if="Object.keys(invoice.items).length">
      <div class="w-100 mt-3">
        <table class="table">
          <thead>
          <tr>
            <th scope="col">SKU</th>
            <th scope="col">Name</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Quantity</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">On Stock</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Price</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Reg</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Order</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(article, index) of invoice.items" v-bind:key="index">
            <td>{{article.sku}}</td>
            <td>{{article.name || "No name"}}</td>
            <td class="d-none d-sm-table-cell text-center">
              <b-icon-dash class="pointer" @click="reduceCount(article.sku)"></b-icon-dash>
              {{article.qtt}}
              <b-icon-plus class="pointer" @click="increaseCount(article.sku)"></b-icon-plus>
            </td>
             <td class="d-none d-sm-table-cell text-center">{{article.maxQtt}}</td>
            <td class="d-none d-sm-table-cell text-center">{{Math.round(article.price).toLocaleString('en')}}kr</td>
            <td class="d-none d-sm-table-cell text-center">{{article.plate || '/'}}</td>
            <td class="d-none d-sm-table-cell text-center align-middle border-start">
              <b-icon-dash @click="decrementToOrder(article)" class="pointer"></b-icon-dash>
              {{inlineQ[article.sku] || 0}}
              <b-icon-plus @click="incrementToOrder(article)" class="pointer"></b-icon-plus>
              <button @click="orderArticle(article.sku, inlineQ[article.sku])" class="ml-2 btn btn-outline-light">
                <b-icon icon="download"></b-icon>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="!showCustom" class="row mx-0">
      <div class="w-100 mt-3 text-right">
        <button class="btn btn-sm btn-secondary pointer" @click="showCustom = true"><b-icon-plus class="mr-1"></b-icon-plus>Add custom item</button>
      </div>
    </div>

    <div v-if="!loading && showCustom" class="row form-card custom-row mx-0 mt-3 pt-3 pb-3">
        <div class="col-3">
          <label for="sku">Codename</label>
          <input v-model="manualRow.codename" type="text" id="sku" class="form-control custom-input" placeholder="SKU">
        </div>
      <div class="col-3">
        <label for="name">Name</label>
        <input v-model="manualRow.name" type="text" id="name" class="form-control custom-input" placeholder="NAME">
      </div>
      <div class="col-2">
        <label for="price">Price</label>
          <input v-model.number="manualRow.price" type="number" id="price" class="form-control custom-input" style="width: 100%">
        </div>
      <div class="col-2">
        <label for="price">Qtt</label>
        <input v-model.number="manualRow.qtt" type="number" id="qtt" class="form-control custom-input" style="width: 100%">
      </div>
      <div class="col-2 d-flex align-items-end">
        <button @click="onSaveCustom" class="btn btn-primary btn-block">Save</button>
      </div>
    </div>

    <div class="row position-relative" v-if="loading">
      <div class="w-100 mt-3 position-absolute text-center">
        <b-icon class="text-dark" icon="arrow-clockwise" animation="spin" font-scale="3"></b-icon>
      </div>
    </div>
    <div v-if="Object.keys(invoice.items).length && this.invoice.client.ttexId && this.invoice.paymentType" class="row mx-0">
      <div class="w-100 mt-3 text-right">
         <b-button @click="resetInvoice" class="ml-3" variant="secondary" size="lg"><b-icon-arrow-counterclockwise class="mr-1"></b-icon-arrow-counterclockwise>Reset</b-button>
        <b-button @click="submitInvoice" class="ml-3 px-5" variant="success" size="lg"><b-icon-check2 class="mr-1"></b-icon-check2>Submit</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
// import 'bootstrap/scss/bootstrap.scss';

import fixed from '../../fixed';

const API_URL = `${fixed.API_URL}/admin`;
export default {
  components: {
    VueTypeaheadBootstrap,
  },
  data: () => ({
    loading: false,
    qrInput: false,
    inputEAN: false,
    showCustom: false,
    clientQuery: '',
    clients: [],
    paymentTypes: [],
    inlineQ: {},
    invoice: {
      client: {},
      items: {},
      desc: '',
      paid: false,
      paidAmount: 0,
      paymentType: 0,
    },
    manualRow: {
      codename: '',
      name: '',
      price: 0,
      qtt: 1,
    },
    desc: '',
    currentTotal: 0,
    qr: '',
    reg: '',
    ean: '',
    sku: '',
    currentOrder: {
      packedAt: null,
      metaData: null,
    },
    shelf: null,
    shelfOptions: [
      { value: null, text: 'NO SHELF' },
      ...Array.from({ length: fixed.localShelfCount }, (_, i) => ({ value: `${i + 1}`, text: `${i + 1}` })),
    ],
  }),
  async mounted() {
    const storedInvoice = localStorage.getItem('invoice');
    // if we have invoice in storage - we resume
    if (storedInvoice) {
      this.invoice = JSON.parse(storedInvoice);
      if (this.invoice.client?.name) this.clientQuery = this.invoice.client.name;
    }

    // Get list of registered clients
    try {
      const { data: clients } = await axios.get(`${API_URL}/clients-list`, { withCredentials: true });
      this.clients = clients;

      const { data: paymentTypes } = await axios.get(`${API_URL}/payment-types`, { withCredentials: true });
      this.paymentTypes = paymentTypes?.values || [];
    } catch (err) {
      this.$toast.error('can\'t get registered clients');
    }
  },
  computed: {
    paymentTypeOptions() {
      return this.paymentTypes.reduce((list, option) => {
        list.push({ text: option.description, value: option.id });
        return list;
      }, []);
    },
  },
  methods: {
    async orderArticle(sku, qtt) {
      if (qtt < 1 || !sku) return;

      this.loading = true;
      try {
        await axios.post(`${API_URL}/poland-order`, { sku, qtt, meta: 'WORKSHOP' }, { withCredentials: true });
        this.$toast.success('Article ordered successfully');
        this.inlineQ = {};
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for that action ✋🏻');
        } else {
          alert(error); // eslint-disable-line
        }
      }
      this.loading = false;
    },
    incrementToOrder(article) {
      if (!this.inlineQ[article.sku]) {
        this.inlineQ[article.sku] = 0;
      }
      this.inlineQ[article.sku] += 1;
      this.inlineQ = { ...this.inlineQ };
    },
    decrementToOrder(article) {
      if (!this.inlineQ[article.codename]) return;
      this.inlineQ[article.codename] -= 1;
    },
    onSaveCustom() {
      if (!this.manualRow.codename || !this.manualRow.price) {
        this.$toast.error('we need sku and price in order to add custom row');
        return;
      }

      if (!this.invoice.items[this.manualRow.codename]) {
        this.$set(this.invoice.items, this.manualRow.codename, {
          sku: this.manualRow.codename,
          maxQtt: 99,
          price: this.manualRow.price,
          name: this.manualRow.name,
          qtt: this.manualRow.qtt,
          custom: true,
          plate: this.reg ? this.reg.toUpperCase() : '',
        });
      } else {
        this.invoice.items[this.manualRow.codename].qtt += 1;
      }

      this.manualRow = {
        codename: '',
        name: '',
        price: 0,
        qtt: 1,
      };
    },
    calculateTotal() {
      this.currentTotal = Object.values(this.invoice.items)
        .map((val) => val)
        .reduce((total, item) => total += (item.qtt * item.price), 0) // eslint-disable-line

      this.invoice.paidAmount = this.invoice.paid ? this.currentTotal : 0;
    },
    async sku2article() {
      if ((this.inputEAN && !this.ean) || (!this.inputEAN && !this.sku)) return;

      // Select url based on input
      const url = this.inputEAN ? `${API_URL}/ean2article?ean=${this.ean}` : `${API_URL}/sku2article?sku=${this.sku}`;

      this.loading = true;
      try {
        const { data } = await axios.get(url, { withCredentials: true });
        if (!this.invoice.items[data.codename] && data.localCount > 0) {
          this.$set(this.invoice.items, data.codename, {
            sku: data.codename,
            maxQtt: data.localCount,
            price: data.productPrices.product_price.price.amount_with_vat,
            name: data.name,
            qtt: 1,
            partNum: this.getProductCode(data.productCodes.productCode),
            plate: this.reg ? this.reg.toUpperCase() : '',
            location: data.localLocation || '',
            custom: false,
          });
        } else if (this.invoice.items[data.codename]) {
          if (this.invoice.items[data.codename].qtt >= this.invoice.items[data.codename].maxQtt) {
            this.$toast.warning('we don\'t have that many of these');
          } else {
            this.invoice.items[data.codename].qtt += 1;
          }
        }
      } catch (err) {
        this.$toast.error(err.response ? err.response.data : 'can\t find that code');
      }

      // Reset inputs
      this.ean = '';
      this.sku = '';
      this.loading = false;
    },
    async qr2articles() {
      if (!this.qr) return;
      if (this.desc) this.desc = '';

      this.loading = true;
      try {
        const { data } = await axios.get(`${API_URL}/qr2articles?qr=${this.qr}`, { withCredentials: true });
        if (!data || !data.length) {
          this.$toast.warning('No products for that code');
        } else {
          data.forEach((product) => {
            if (this.invoice.items[product.sku]) {
              // Item already exists, update quantities
              this.invoice.items[product.sku].qtt += product.count;
              this.invoice.items[product.sku].maxQtt += product.count;
            } else {
              // New item, add it
              this.$set(this.invoice.items, product.sku, {
                sku: product.sku,
                maxQtt: product.count,
                price: product.webPrice,
                name: product.name || product.ssku,
                qtt: product.count,
                partNum: product.num,
                location: 'packed',
                custom: true, // to avoid local stock updates
              });
            }
          });
          if (data[0].metaData) {
            const meta = data[0].metaData;
            this.desc = meta;
            // Keep track of order info so we can add shelf
            this.currentOrder.metaData = meta;
            this.currentOrder.packedAt = data[0]?.packedAt || null;
          }
        }
      } catch (err) {
        this.$toast.error(err.response ? err.response.data : 'can\t find products from that code');
      }
      this.qr = '';
      this.loading = false;
    },
    reduceCount(sku) {
      if (this.invoice.items[sku].qtt === 1) {
        this.invoice.items[sku] = null;
        delete this.invoice.items[sku];
      } else {
        this.invoice.items[sku].qtt -= 1;
      }
    },
    increaseCount(sku) {
      if (this.invoice.items[sku].maxQtt <= this.invoice.items[sku].qtt) return;
      this.invoice.items[sku].qtt += 1;
    },
    blankInvoice() {
      return {
        client: {},
        items: {},
        desc: '',
        paid: false,
        paidAmount: 0,
        paymentType: 0,
      };
    },
    resetInvoice() {
      this.invoice = this.blankInvoice();
      this.desc = '';
      this.ean = '';
      this.reg = '';
    },
    async submitInvoice() {
      if (!this.invoice.client?.name || !this.invoice.client?.email || !this.invoice.client?.ttexId || !this.clientQuery) {
        this.$toast.error('Invalid user selected');
        return;
      }

      if (!this.invoice.paymentType) {
        this.$toast.warning('Please select valid payment type');
        return;
      }

      if (!Object.keys(this.invoice.items).length) {
        this.$toast.warning('no articles for the invoice');
        return;
      }

      // we copy the invoice, so we keep the structure if req fails
      const payload = { ...this.invoice };
      payload.items = Object.values(payload.items).map((val) => val);

      if (!payload.desc) {
        payload.desc = prompt('Add invoice description if needed', ''); // eslint-disable-line
      }

      this.loading = true;
      try {
        // store shelf if selected
        if (this.storeShelf()) {
          await axios.put(`${fixed.API_URL}/admin/set-package-shelf`,
            { ...this.currentOrder, shelf: this.shelf },
            { withCredentials: true });
        }
        // Store invoice
        const { data } = await axios.post(`${API_URL}/generate-invoice`, payload, { withCredentials: true, responseType: 'arraybuffer' });
        // Reset invoice and last tracked order
        this.resetCurrentOrder();
        this.resetInvoice();
        // At the end print the stored invoice
        const blob = new Blob([data], { type: 'application/pdf' });
        const blobURL = URL.createObjectURL(blob);
        window.open(blobURL);
      } catch (err) {
        this.$toast.error(err?.response?.statusText || 'Can\'t store the invoice');
      }
      this.loading = false;
    },
    storeShelf() {
      return this.shelf !== null && this.currentOrder.metaData !== null && this.currentOrder.packedAt !== null;
    },
    resetCurrentOrder() {
      this.currentOrder = {
        metaData: null,
        packedAt: null,
      };
    },
    getProductCode(codes) {
      for (let i = 0; i < codes.length; i += 1) {
        if (codes[i].type === 'manufacturer') return codes[i].code;
      }
      return '';
    },
  },
  watch: {
    invoice: {
      handler() {
        localStorage.setItem('invoice', JSON.stringify(this.invoice));
      },
      deep: true,
    },
    'invoice.items': {
      handler() {
        this.calculateTotal();
      },
      deep: true,
    },
  },
};
</script>

<style>
input[type="text"] {
  font-size: 1.2rem;
}

.plate {
  position: relative;
  height: 65px;

  background-image: url("../../assets/plate.png");
  background-repeat: no-repeat;
  background-position: top;
  background-size: 80px;
  background-size: 300px 79px;
}

.plate > input[type="text"] {
  background: transparent;
  color: #111;
  width: 200px;
  margin-top: 15px;
  height: 36px;
  font-size: 2.7rem;
  font-weight: bold;
  text-transform: uppercase;
  border: 0;
  box-shadow: none;
  padding: 0;
  text-align: center;
  line-height: 1.3;
  outline: none;
}

/* The global input[type="text"] rule above enlarges text inputs only;
   keep all custom-item fields the same height */
.custom-row .form-control {
  font-size: 1rem;
}

.shelf[disabled] {
  color: var(--text-faint) !important;
}

.scan-bar {
  border-left: 4px solid var(--accent) !important;
}

.pos-switch {
  background: var(--surface-2);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-sm);
}

.cash-display {
  position: relative;
  height: 60px;
  border-radius: var(--radius);
  padding: 3%;

  background: linear-gradient(160deg, rgba(47, 184, 102, 0.25), rgba(47, 184, 102, 0.08));
  border: 1px solid rgba(47, 184, 102, 0.4);
  color: var(--text);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
.cash-display > span {
  font-size: 2.1rem;
  margin-top: 30px;
}
</style>
